import React, { useState, useRef } from 'react'
import { css } from '@emotion/react'
import { node } from 'prop-types'

import CloseIcon from '@/assets/icons/close.inline.svg'
import useIsomorphicLayoutEffect from '@/hooks/useIsomorphicLayoutEffect'
import useOutsideClick from '@/hooks/useOutsideClick'
import { usePreventScroll } from '@/utils/browser'

import Search from '../Search'
import Logo from './Logo'

const expandedSearchCss = css`
  width: 100vw;
  z-index: 1000;

  &,
  > div {
    position: fixed;
    top: 0;
    left: 0;
  }

  > div {
    height: 60px;
    width: 100vw;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
  }

  .autocomplete-results {
    .autocomplete-list {
      max-height: calc(100vh - 120px);
    }
  }
`

const searchIconWrapperCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
`

const searchInputWrapperCss = css`
  width: 100%;
`

const closeIconWrapperCss = css`
  display: flex;
  align-items: center;
  margin-left: 16px;
  cursor: pointer;
`

const stopPropagation = (e) => e.stopPropagation()

const MobileSearch = ({ logo = <Logo /> }) => {
  const searchInputRef = useRef(null)

  const [isOpen, setIsOpen] = useState(false)
  const toggleOpen = () => setIsOpen(!isOpen)

  usePreventScroll(isOpen)
  useOutsideClick(() => {
    // To prevent a race condition that could cancel the event and stop navigation to the selected item.
    setTimeout(() => setIsOpen(false), 200)
  }, searchInputRef)

  useIsomorphicLayoutEffect(() => {
    if (isOpen && searchInputRef?.current) {
      searchInputRef.current.focus()
    }
  }, [isOpen])

  if (!isOpen) {
    return (
      <div css={searchIconWrapperCss} onClick={toggleOpen}>
        <Search />
      </div>
    )
  }

  return (
    <div css={expandedSearchCss} onClick={toggleOpen}>
      <div onClick={stopPropagation}>
        {logo}
        <Search
          isInputVisible
          css={searchInputWrapperCss}
          searchInputRef={searchInputRef}
          onKeyPress={toggleOpen}
        />

        <div css={closeIconWrapperCss} onClick={toggleOpen}>
          <CloseIcon />
        </div>
      </div>
    </div>
  )
}

MobileSearch.propTypes = {
  logo: node,
}

export default MobileSearch
